import { Button } from "antd";
import { useAuthRole  } from "./PDFFooter";

const PDFControlsHeader = ({ displayName, remainingTime, loading, error, pdfFullyLoaded, isFullScreen, isExitingFullscreen, isCloseDisabled, onToggleFullscreen, onClose }) => {
  const { isAdminRole } = useAuthRole();
  const effectiveRemainingTime = isAdminRole ? 0 : remainingTime;
  const effectiveCloseDisabled = isAdminRole ? false : isCloseDisabled;

  return (
    <div className="pdf-controls-header">
      <div className="pdf-title">
        {loading ? "Loading PDF..."
          : error ? "Error loading PDF"
          : !pdfFullyLoaded ? "Preparing PDF..."
          : (
            <>
              <div style={{ fontWeight: 'bold' }}>{displayName}</div>
              {!isAdminRole && effectiveRemainingTime > 0 && ( 
                <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
                  You can close in {effectiveRemainingTime} second{effectiveRemainingTime !== 1 ? "s" : ""}
                </div>
              )}
            </>
          )}
      </div>

      {!isFullScreen && (
        <div className="pdf-controls">
          <Button
            onClick={onToggleFullscreen}
            className="pdf-control-btn"
            disabled={loading || error || !pdfFullyLoaded || isExitingFullscreen}
          >
            Fullscreen
          </Button>
          <Button
            onClick={onClose}
            disabled={effectiveCloseDisabled}
            className="pdf-close-btn"
            style={{ opacity: effectiveCloseDisabled ? 0.5 : 1, cursor: effectiveCloseDisabled ? 'not-allowed' : 'pointer' }}
          >
            Close {!isAdminRole && effectiveRemainingTime > 0 && `(${effectiveRemainingTime}s)`} 
          </Button>
        </div>
      )}
    </div>
  );
};

export default PDFControlsHeader;